import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
    selector: 'app-insights-section',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [
        TranslateModule,
        CommonModule,
        MatIconModule,
        SlickCarouselModule,
    ],
    template: `
        <div class="tw-hidden md:tw-grid tw-bg-[#f9fafb]">
            <div class="tw-text-center sm:tw-text-left tw-px-[5vw] tw-pt-8">
                <p
                    class="tw-w-full tw-text-[28px] tw-text-[#0F3172] tw-font-bold tw-leading-[140%]"
                >
                    Insights
                </p>
            </div>
            <div
                class="md:tw-grid tw-pt-[25px] tw-px-[5vw] tw-grid tw-grid-cols-4 tw-gap-6 sm:tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 xl:tw-grid-cols-4"
            >
                @for (data of displayedInsights; track data) {
                    <div
                        class="tw-relative tw-cursor-pointer"
                        (click)="insightsDetails.emit(data)"
                    >
                        @if (data?.campaigndetails?.promoHat) {
                            <div
                                class="tw-absolute tw-left-0 tw-top-4 tw-bg-[#FFA53C] tw-text-[#FFFFFF] tw-text-[14px] tw-font-bold tw-py-1 tw-px-6 tw-h-[31px] tw-text-center tw-rounded-r-full tw-z-[2] tw-content-center"
                            >
                                {{ data?.campaigndetails?.promoHat }}
                            </div>
                        }
                        <div
                            class="tw-w-full tw-aspect-[4/3] tw-overflow-hidden tw-rounded-t-xl"
                        >
                            <img
                                class="tw-w-full tw-h-full tw-object-cover"
                                [src]="data?.campaigndetails?.campaignImageUrl"
                                alt="Insights"
                            />
                        </div>
                        <div
                            class="tw-flex tw-flex-col tw-px-7 tw-py-5 tw-rounded-xl tw-h-[164px]"
                            style="background: linear-gradient(179.68deg, rgba(198, 198, 198, 0) 3.29%, #e5e5e5 63.2%);"
                        >
                            <span
                                class="tw-text-[#002D86] tw-font-bold tw-mb-2 tw-text-[16px] tw-break-words"
                                [innerHTML]="
                                    truncate(
                                        removeHtmlTags(
                                            data?.campaigndetails?.campaignName
                                        ),
                                        50
                                    )
                                "
                            ></span>
                            <span
                                class="tw-text-[#2B2B2B] tw-text-[13px] content-details default-html tw-break-words"
                                [innerHTML]="
                                    truncate(
                                        data?.campaigndetails
                                            ?.campaignDescription,
                                        110
                                    )
                                "
                            ></span>
                        </div>
                    </div>
                }
            </div>
            <div
                class="tw-hidden md:tw-flex tw-justify-center tw-items-center tw-my-6"
            >
                @if (currentPage * itemsPerPage < insightsData.length) {
                    <button
                        class="tw-flex tw-items-center tw-justify-center tw-w-[137px] tw-h-[44px] tw-bg-white tw-text-[#00359D] tw-text-[14px] tw-font-bold tw-rounded-[32px] tw-border tw-border-[#00359D] tw-whitespace-nowrap tw-text-center"
                        type="submit"
                        (click)="showMoreInsights()"
                    >
                        {{ 'COMMON.VIEW_MORE' | translate }}
                        <mat-icon class="tw-ml-2">expand_more</mat-icon>
                    </button>
                }
            </div>
        </div>

        <!-- MOBILE INSIGHTS CODE -->
        <div class="tw-block md:tw-hidden tw-bg-[#f9fafb]">
            <div
                class="tw-text-center sm:tw-text-left tw-px-[5vw] tw-pt-4 md:tw-pt-8"
            >
                <p
                    class="tw-w-full tw-text-[22px] md:tw-text-[30px] tw-text-[#0F3172] tw-font-bold tw-leading-[100%] tw-py-4"
                >
                    Insights
                </p>
            </div>
            <div class="tw-px-[1rem] tw-pb-6">
                <ngx-slick-carousel
                    class="carousel"
                    #slickModal="slick-carousel"
                    [config]="slideConfig"
                    (afterChange)="afterChange($event)"
                    (beforeChange)="beforeChange($event)"
                >
                    @for (data of insightsData; track data) {
                        <div ngxSlickItem class="tw-mb-16">
                            <div
                                class="tw-relative tw-cursor-pointer tw-w-[249px] mx-auto"
                                (click)="insightsDetails.emit(data)"
                            >
                                @if (data?.campaigndetails?.promoHat) {
                                    <div
                                        class="tw-absolute tw-left-0 tw-top-4 tw-bg-[#FFA53C] tw-text-[#FFFFFF] tw-text-[12px] md:tw-text-[14px] tw-font-bold tw-py-1 tw-px-6 tw-h-[31px] tw-text-center tw-rounded-r-full tw-z-[2] tw-content-center"
                                    >
                                        {{ data?.campaigndetails?.promoHat }}
                                    </div>
                                }
                                <div
                                    class="tw-w-full tw-aspect-[4/3] tw-overflow-hidden tw-rounded-t-xl"
                                >
                                    <img
                                        class="tw-w-full tw-h-full tw-object-cover"
                                        [src]="
                                            data?.campaigndetails
                                                ?.campaignImageUrl
                                        "
                                        alt="Insights"
                                    />
                                </div>
                                <div
                                    class="tw-flex tw-flex-col tw-px-7 tw-py-5 tw-rounded-xl tw-h-[156px]"
                                    style="background: linear-gradient(179.68deg, rgba(198, 198, 198, 0) 3.29%, #e5e5e5 63.2%);"
                                >
                                    <span
                                        class="tw-text-[#002D86] tw-font-bold tw-mb-2 tw-text-[14px] tw-break-words"
                                        [innerHTML]="
                                            truncate(
                                                removeHtmlTags(
                                                    data?.campaigndetails
                                                        ?.campaignName
                                                ),
                                                50
                                            )
                                        "
                                    ></span>
                                    <span
                                        class="tw-text-[#2B2B2B] tw-text-[14px] tw-h-[156px] content-details tw-break-words"
                                        [innerHTML]="
                                            truncate(
                                                data?.campaigndetails
                                                    ?.campaignDescription,
                                                75
                                            )
                                        "
                                    ></span>
                                </div>
                            </div>
                        </div>
                    }
                </ngx-slick-carousel>
            </div>
        </div>
    `,
    styleUrl: './insights-section.component.scss',
})
export class InsightsSectionComponent {
    @Input() insightsData: any[] = [];
    @Output() insightsDetails = new EventEmitter<any>();

    itemsPerPage = 4;
    currentPage = 1;
    displayedInsights: any[] = [];
    currentSlide = 0;

    slideConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow:
            '<button class="slick-prev"><img src="/assets/images/icons/arrow-left.svg" alt="Previous" style="width: 60%; filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(213deg) brightness(104%) contrast(97%);" /></button>',
        nextArrow:
            '<button class="slick-next"><img src="/assets/images/icons/arrow-right.svg" alt="Next" style="width: 60%; filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(213deg) brightness(104%) contrast(97%);" /></button>',
    };

    ngOnInit() {
        this.updateDisplayedInsights();
    }

    ngOnChanges() {
        this.updateDisplayedInsights();
    }

    updateDisplayedInsights() {
        const endIndex = this.currentPage * this.itemsPerPage;
        this.displayedInsights = this.insightsData.slice(0, endIndex);
    }

    showMoreInsights() {
        if (this.currentPage * this.itemsPerPage < this.insightsData.length) {
            this.currentPage++;
            this.updateDisplayedInsights();
        }
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }

    removeHtmlTags(text: string) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return doc.body.textContent || '';
    }

    truncate(str: string, length: number): string {
        str = str || '';
        return str.length > length ? str.slice(0, length) : str;
    }
}
